export const inclinedMonthNames =
  'января февраля марта апреля мая июня июля августа сентября октября ноября декабря'.split(' ');
